import tw from 'twin.macro'

const NameStyles = tw.span`mr-1 mt-2 text-sm font-bold text-black opacity-75 text-base leading-normal`

const Name = ({ name }) => {
  return <NameStyles>{name}</NameStyles>
}

export default Name
